

export default function InquiryListPanel({ inquiries, activeTab, onSelect, loading }) {
  // filter inquiries by tab
  const filtered = inquiries.filter(inq => {
    if (activeTab === 'new')       return !inq.replied && !inq.closed;
    if (activeTab === 'replied')   return inq.replied && !inq.closed;
    if (activeTab === 'closed')    return inq.closed;
    return true; // 'all'
  });

  return (
    <div className="flex-1 bg-white rounded-2xl shadow-[0_1px_4px_rgba(0,0,0,0.05)] p-5 flex flex-col">
      {loading ? (
        <div className="flex-1 flex items-center justify-center">
          <svg
            className="w-8 h-8 animate-spin text-[#2563EB]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
        </div>
      ) : (
        <div className="flex-1 overflow-y-auto">
          {/* Header row */}
          <div className="grid grid-cols-5 gap-4 pb-2 mb-2 border-b border-[#E5E7EB] text-sm font-medium text-[#6B7280]">
            <div>Name</div>
            <div>Email</div>
            <div>Type</div>
            <div>Date</div>
            <div>Status</div>
          </div>

          {/* Inquiry rows */}
          {filtered.map(inq => (
            <div
              key={inq._id}
              onClick={() => onSelect(inq._id)}
              className="grid grid-cols-5 gap-4 items-center py-3 px-2 rounded-lg hover:bg-[#F3F4F6] cursor-pointer"
            >
              {/* Name */}
              <div className="text-[#1F2937] font-medium truncate">
                {inq.name}
              </div>

              {/* Email */}
              <div className="text-[#4B5563] truncate">
                {inq.email}
              </div>

              {/* Type badge */}
              <div>
                <span
                  className={`inline-block px-2 py-1 text-xs font-medium rounded-full ${
                    {
                      Guest:  'bg-[#F59E0B] text-white',
                      Driver: 'bg-[#8B5CF6] text-white',
                      Host:   'bg-[#3B82F6] text-white',
                      Other:  'bg-[#9CA3AF] text-white',
                    }[inq.type] || 'bg-[#9CA3AF] text-white'
                  }`}
                >
                  {inq.type}
                </span>
              </div>

              {/* Created date */}
              <div className="text-[#6B7280] text-sm">
                {new Date(inq.createdAt).toLocaleString()}
              </div>

              {/* Status badge */}
              <div>
                <span
                  className={`inline-block px-2 py-1 text-xs font-semibold rounded-full ${
                    inq.closed
                      ? 'bg-[#6B7280] text-white'
                      : inq.replied
                        ? 'bg-[#2563EB] text-white'
                        : 'bg-[#10B981] text-white'
                  }`}
                >
                  {inq.closed ? 'Closed' : inq.replied ? 'Replied' : 'New'}
                </span>
              </div>
            </div>
          ))}

          {/* Empty state */}
          {!loading && filtered.length === 0 && (
            <div className="text-center text-[#6B7280] mt-10">
              No inquiries found.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
